<h1 mat-dialog-title>{{ data.title }}</h1>
<div class="container">
  <mat-card-content style="width: 70%; margin: auto">
    <form [formGroup]="ingresoForm">
      <div
        formGroupName="insumoAlmacen"
        class="row"
        style="display: flex; flex-wrap: wrap; justify-content: space-between"
      >
        <mat-form-field appearance="outline">
          <mat-label>Cantidad</mat-label>
          <input
            matInput
            placeholder="Cantidad"
            formControlName="cantidad"
            name="cantidad"
            type="number"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Costo</mat-label>
          <input
            matInput
            placeholder="Costo"
            formControlName="costo"
            name="Costo"
            type="number"
            required
          />
        </mat-form-field>
      </div>

      <mat-dialog-actions align="center">
        <button mat-button mat-dialog-close>Cancelar</button>
        <button
          mat-raised-button
          style="background-color: #e95a1a; color: white"
          (click)="updateInsumo()"
        >
          {{ data.title }}
        </button>
      </mat-dialog-actions>
    </form>
  </mat-card-content>
</div>
